
import {
    apiDistributionWithdrawLists,
    apiDistributionWithdrawAllow,
    apiDistributionWithdrawReject,
    apiDistributionWithdrawComplete,
} from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import addDistribution from "@/components/shop/distribution/add_distribution.vue";
import setLeader from "@/components/shop/distribution/set_leader.vue";
import setMerchant from "@/components/shop/distribution/set_merchant.vue";
import LsDialog from "@/components/ls-dialog.vue";
@Component({
    components: {
        lsPagination,
        setLeader,
        addDistribution,
        setMerchant,
        LsDialog,
    },
})
export default class ShopList extends Vue {
    /** S Data **/
    $refs!: { addDistributionRef: any; setLeaderRef: any; setMerchantRef: any };
    apiDistributionWithdrawLists = apiDistributionWithdrawLists;

    pager: RequestPaging = new RequestPaging();

    searchObj = {
        name: "",
        status: "",
    };

    /** E Data **/
    /** S Methods **/

    completeWithdraw(row: any) {
        apiDistributionWithdrawComplete({
            id: row.id,
        }).then((res: any) => {
            this.getShopLists();
        });
    }

    rejectWithdraw(reason: string, id: number) {
        if(!reason) {
            this.$message.error("请输入拒绝原因");
            return;
        }
        apiDistributionWithdrawReject({
            id,
            fail_reason: reason,
        }).then((res: any) => {
            this.getShopLists();
        });
    }

    confirmWithdraw(row: any) {
        apiDistributionWithdrawAllow({
            id: row.id,
        }).then((res: any) => {
            this.getShopLists();
        });
    }

    handleMerchant(row: any) {
        this.$refs.setMerchantRef.open(row.id);
    }

    handleSetLeader(row: any) {
        this.$refs.setLeaderRef.open(row.id);
    }

    handleAdd() {
        this.$refs.addDistributionRef.open(null);
    }

    // 编辑分销商
    handleEdit(row: any): void {
        this.$refs.addDistributionRef.open(row.id);
    }

    // 获取分销商列表
    getShopLists(page?: number): void {
        console.log(page)
        page && (this.pager.page = page);
        this.pager.request({
            callback: apiDistributionWithdrawLists,
            params: {
                ...this.searchObj,
            },
        });
    }

    // 重置搜索
    reset(): void {
        Object.keys(this.searchObj).map((key) => {
            this.$set(this.searchObj, key, "");
        });
        this.getShopLists(1);
    }

    /** E Methods **/

    /** S ods **/
    created() {
        this.getShopLists(1);
    }
}
